<script lang="ts">
	import { Popover, PopoverContent, PopoverTrigger } from "#lib/web-ui/ui/popover/index.js";
	import { getGlossaryContext } from "./glossary-context.svelte";
	import GlossaryOpenButton from "./glossary-open-button.svelte";

	interface Props {
		term: string;
		text: string;
	}

	let { term, text }: Props = $props();

	const glossary = getGlossaryContext();
	const entry = $derived(glossary.find(term));
</script>

{#if entry}
	<Popover>
		<PopoverContent
			class="max-h-[70vh] w-80 max-w-[calc(100vw-2rem)] overflow-y-auto"
			data-testid="glossary-term-popover"
		>
			<p class="text-popover-foreground text-base font-semibold">{entry.term}</p>
			{#if entry.aliases.length > 0}
				<p class="text-muted-foreground mt-1 text-xs">
					{glossary.copy.alsoKnownAsLabel}
					{entry.aliases.join(", ")}
				</p>
			{/if}
			<p class="text-popover-foreground mt-3 text-sm">{entry.explanation}</p>
			{#if entry.example}
				<p class="text-muted-foreground mt-3 text-sm">{entry.example}</p>
			{/if}
			{#if entry.whyItMatters}
				<p class="text-primary mt-3 text-xs font-semibold tracking-wide uppercase">
					{glossary.copy.whyLabel}
				</p>
				<p class="text-popover-foreground mt-1 text-sm">{entry.whyItMatters}</p>
			{/if}
			<p class="mt-4 text-sm">
				<GlossaryOpenButton />
			</p>
		</PopoverContent>
		<PopoverTrigger
			class="decoration-primary cursor-pointer text-inherit underline decoration-dotted decoration-2 underline-offset-4"
		>
			{text}
		</PopoverTrigger>
	</Popover>
{:else}
	{text}
{/if}
